import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import LoginHeader from './components/LoginHeader';
import LoginForm from './components/LoginForm';
import SecurityBadges from './components/SecurityBadges';
import LoginFooter from './components/LoginFooter';
import Threads from '../../Threads/Threads';

const TOKEN_EXPIRY_MINUTES = 60;

function isTokenValid() {
  const token = localStorage.getItem('authToken');
  const expiry = localStorage.getItem('authTokenExpiry');
  if (!token || !expiry) return false;
  return new Date().getTime() < Number(expiry);
}

const AdminLogin = () => {
  const navigate = useNavigate();
  const [isAuthenticated, setIsAuthenticated] = useState(false);

  useEffect(() => {
    if (isTokenValid()) {
      setIsAuthenticated(true);
      navigate('/api-documentation-hub');
    } else {
      // Clear any stale session
      localStorage.removeItem('authToken');
      localStorage.removeItem('authTokenExpiry');
      localStorage.removeItem('userData');
      // ...remove other user-related localStorage items as needed
      setIsAuthenticated(false);
    }
  }, [navigate]);

  const handleLogin = (userData) => {
    const expiry = new Date().getTime() + TOKEN_EXPIRY_MINUTES * 60 * 1000;
    localStorage.setItem('authToken', userData.token);
    localStorage.setItem('authTokenExpiry', expiry);
    localStorage.setItem('userData', JSON.stringify(userData));
    localStorage.setItem('_id', userData._id);
    localStorage.setItem('first_name', userData.first_name);
    localStorage.setItem('email', userData.email);
    localStorage.setItem('phone', userData.phone);
    localStorage.setItem('role', String(userData.role));
    localStorage.setItem('code', userData.code || '');
    localStorage.setItem('image', userData.image || '');
    localStorage.setItem('def_addr', userData.def_addr || '');
    localStorage.setItem('book_addr', userData.book_addr || '');

    if (userData.client_details && (userData.role === "3" || userData.role === "4")) {
      localStorage.setItem('client_details', JSON.stringify(userData.client_details));
    } else {
      localStorage.removeItem('client_details');
    }

    setIsAuthenticated(true);
  };

  if (isAuthenticated) {
    return (
      <div className="min-h-screen bg-background flex items-center justify-center">
        <div className="text-center">
          <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-primary mx-auto mb-4"></div>
          <p className="text-muted-foreground">Redirecting to dashboard...</p>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gradient-to-br from-background via-muted/20 to-background relative">
      <div
        style={{
          width: '100%',
          height: '100%',
          position: 'absolute',
          top: 0,
          left: 0,
          zIndex: 0,
        }}
      >
        <Threads
          amplitude={1}
          distance={0}
          enableMouseInteraction={true}
        />
      </div>

      {/* Login Content */}
      <div className="min-h-screen flex items-center justify-center p-4 relative z-10">
        <div className="w-full max-w-md">
          <div className="bg-card border border-border rounded-2xl shadow-modal p-8">
            <LoginHeader />
            <LoginForm onLogin={handleLogin} />
            <SecurityBadges />
          </div>
          <div className="mt-8">
            <LoginFooter />
          </div>
        </div>
      </div>

      {/* Background Pattern */}
      <div className="fixed inset-0 -z-10 overflow-hidden">
        <div className="absolute -top-40 -right-40 w-80 h-80 bg-primary/5 rounded-full blur-3xl"></div>
        <div className="absolute -bottom-40 -left-40 w-80 h-80 bg-accent/5 rounded-full blur-3xl"></div>
      </div>
    </div>
  );
};

export default AdminLogin;
